import React from 'react';
import { Card } from '@tmap/mmm-style-guide/src/Card';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';

import imageUrlBuilder from '@sanity/image-url';
import client from '../../client';
import ConditionalLazyLoad from '../conditional-lazy-load';

const builder = imageUrlBuilder(client);

const CalloutCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  padding: theme.spacing(4),
}));

const CalloutPicture = styled('picture')(() => ({
  borderRadius: '50%',
}));

const CalloutImg = styled('img')(() => ({
  borderRadius: '50%',
}));

function CalloutBox(props) {
  const {
    RecursiveComponent,
    profileImage,
    lead,
    body,
  } = props;
  return (
    <CalloutCard elevation={0}>
      <Grid container spacing={4}>
        {profileImage && profileImage.asset && (
          <Grid item>
            <ConditionalLazyLoad shouldLazyLoad offset={1500}>
              <CalloutPicture>
                <source
                  srcSet={
                    builder
                      .image(profileImage)
                      .format('webp')
                      .width(60)
                      .height(60)
                      .url()
                  }
                />
                <CalloutImg
                  src={
                    builder
                      .image(profileImage)
                      .width(60)
                      .height(60)
                      .url()
                  }
                  height={60}
                  width={60}
                  alt={(profileImage || {}).alt}
                />
              </CalloutPicture>
            </ConditionalLazyLoad>
          </Grid>
        )}
        <Grid item xs>
          {lead && (
            <Typography variant='h6' fontWeight={700} gutterBottom>{lead}</Typography>
          )}
          {body && (
            <RecursiveComponent value={body} nested />
          )}
        </Grid>
      </Grid>
    </CalloutCard>
  );
}

export default CalloutBox;
